import React, {useState} from "react";
import ResponseViewer from "../ResponseViewer";
import {useCopyClipboard} from "../../utils/helpers";
import ContactUs from "../ContactUs";

function GetStartedMainLayout() {
  const {copyStatus, handleCopyClipboard} = useCopyClipboard();
  const [logincontainer, setLoginContainer] = useState(false);
  const loginCurl = "curl --location 'https://<hostname>/token' \ \n"+
  "--header 'Content-Type: application/x-www-form-urlencoded' \ \n"+
  "--data-urlencode 'clientId=xxxx-xxxxx' \ \n"+
 " --data-urlencode 'clientSecret=xxxxx-xxxx' \n";
  const getStartedCurl="curl -H &quot;Authorization: Bearer <your token>&quot; &quot;https://<hostname>/api/v1/jobs-hiring-team/{jobId}&quot;";
  const handleClick = (event, id) => {
    event.preventDefault();

    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({block: "center", behavior: "smooth"});
    }
  };
  const copyClipboard =(curlCommand)=>{
    handleCopyClipboard(curlCommand);
    if (curlCommand==loginCurl) {
      setLoginContainer(true);
    } else {
      setLoginContainer(false);
    }
  };
  const jobId="{jobId}";
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="main-section getStarted api-detail" data-index={0} id="Introduction" >
          <h1 id="Introduction" className="side-menu-methods">Introduction</h1>
          <p>The Phenom API is an easy-to-use REST API for developers to interact with Phenom products. It can be used to build applications on top of Phenom products.</p>
          <p>The Phenom API is a Representational State Transfer (REST) API consisting of HTTP endpoints. Authentication is required to use the endpoints.</p>
          <p>Refer to the <a href="#Getting Started" onClick={(e) => handleClick(e, "Getting Started")}>Getting started</a> page to start using the APIs and <a href="#Authentication API" data-testid={"Authentication-Link"} onClick={(e) => handleClick(e, "Authentication API")}>Authentication API</a> page for authentication.</p>
        </div>

        <div className="main-section getStarted api-detail"data-index={1} id="Authentication API">
          <h1 id="Authentication API" className="side-menu-methods" data-testid={"Authentication API"}>Authentication API</h1>
          {/* Login token component  */}
          <div className="method-example-part example-request">
            <div className="highlight">
              <pre className="highlight plaintext">
                <div className="copy-clipboard"
                  onClick={() => copyClipboard(loginCurl)}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>Copy to Clipboard</title>
                    <path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14z"></path>
                  </svg>
                  <span data-testid="login-container" id={logincontainer&&copyStatus ? "active" : "custom-tooltip"}>copied!</span>
                </div>
                <code className="codeBlock">
                  {loginCurl.split("\\\n").map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </code>
              </pre>
            </div>
          </div>
          <p>All APIs use the OAuth 2.0 (OAuth2) protocol for authentication and authorization. To authenticate the API, you must include an API token (generally referred to as a bearer token) in each API call. A bearer token is a string that is used to give the owner of the token access to a resource. The token should be passed as an "Authorization" header using the "Bearer" authentication scheme.</p>
          <h2 id="Create a API token" className="method-name side-menu-methods" data-index={1}>Create a API token</h2>
          {/* ADD other components here  */}
          <p className="margin-12">To create an API token, follow the steps below:</p>
          <ol>
            <li className="subText">Contact api-management@phenom.com to register your application.</li>
            <li className="subText">Login url, clientId and clientSecret will be provided after registration.</li>
            <li className="bold subText">All user-generated tokens should be secured.</li>
          </ol>
        </div>

        <div className="main-section getStarted api-detail" data-index={2} id="Getting Started">
          <h1 id="Getting Started" className="side-menu-methods">Getting started </h1>
          <p><span className="bold font-18" >Get an authentication token</span></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp; Follow the steps in <a href="#Authentication API" onClick={(e) => handleClick(e, "Authentication API")}>Authentication</a> to get an authentication token.</p>
          <p><span className="bold font-18" >Make a request</span></p>
          <div className="method-example-part example-request">
            <div className="highlight">
              <pre className="highlight plaintext">
                <div className="copy-clipboard"
                  data-testid ="copy-loginCurl-button"
                  onClick={() => copyClipboard(getStartedCurl)}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>Copy to Clipboard</title>
                    <path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14z">
                    </path>
                  </svg>
                  <span id={(!logincontainer)&&copyStatus ? "active" : "custom-tooltip"}>copied!</span>
                </div><code className="codeBlock">curl -H "Authorization: Bearer &lt;your token&gt;" "https://&lt;hostname&gt;/api/v1/jobs-hiring-team/{jobId}"
                </code></pre></div> </div>
          <p className="margin-12">After getting the authentication token, you can interact with the API.</p>
          <p className="bold margin-12">To include a token in an API call, pass the token in header as "Authorization" using the "Bearer" authentication scheme.</p>
          <p className="margin-12">All API calls to Phenom APIs should use HTTPS.</p>
          <p><span className="bold font-18" >How to Navigate to Documentation?</span></p>
          <p className="margin-12">There are two ways to view the documentation: </p>
          <ul> <li className="subText">
            <span className="bold">To view the documentation of a specific entity:</span>
          You are displayed with the list of Entities on the home page, Click on any entity to view the documentation of that particular entity. </li>
          <p>OR</p>
          <li className="subText"> <span className="bold">To view the documentation of all entities:</span> Click on 'View Documentation' button on the home page to navigate to the documentation page where you are displayed with the documentation of all the entities at once. </li>
          </ul>
          <p></p>
        </div>
      </div>
    </div>
  );
}

export default GetStartedMainLayout;
